// @ts-nocheck
import React from "react";
import { Dropdown } from "react-bootstrap";
import { Mail, Download } from "lucide-react";
import styles from "./SearchData.module.scss";

export default function SearchResultsBar({
  quickSearchFor,
  dataCount,
  searchQuery,
  userData,
  onExportExcel,
  onExportPdf,
  onExportFlockNotes,
  onSendEmail,
}: any): JSX.Element {
  const count = dataCount > 0 ? dataCount : "0";
  return (
    <div className={styles.toolbar}>
      <div className={styles.countBlock}>
        <div className={styles.countBadge}>{count}</div>
        <div>
          <h3 className={styles.countTitle}>
            {quickSearchFor ? "Quick Search Results" : "Search Results"}
          </h3>
          <p className={styles.countMeta}>
            {Number(count) === 1 ? "record" : "records"}
            {quickSearchFor ? ` — ${quickSearchFor}` : ""}
            {searchQuery?.searchFor
              ? ` · ${String(searchQuery.searchFor).charAt(0).toUpperCase()}${String(
                  searchQuery.searchFor,
                ).slice(1)}`
              : ""}
          </p>
        </div>
      </div>
      {userData && userData.userRole === "ADMIN" ? (
        <div className={styles.toolbarActions}>
          <Dropdown className="d-inline-flex">
            <Dropdown.Toggle
              className={styles.ghostBtn}
              id="search-export"
              style={{ height: 38 }}
            >
              <Download size={14} style={{ marginRight: 6, verticalAlign: -2 }} />
              Export
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={onExportExcel}>Excel</Dropdown.Item>
              <Dropdown.Item onClick={onExportPdf}>PDF</Dropdown.Item>
              {searchQuery.searchFor === "couple" ? (
                <Dropdown.Item onClick={onExportFlockNotes}>Flock Note Excel</Dropdown.Item>
              ) : null}
            </Dropdown.Menu>
          </Dropdown>
          <button type="button" className={styles.mailBtn} onClick={onSendEmail}>
            <Mail size={16} /> Send Email
          </button>
        </div>
      ) : null}
    </div>
  );
}
